<script>
import baseInput from '../mixins/baseInput'

export default {
    name: 'InputLine',

    mixins: [baseInput],

    inheritAttrs: false,

    props: {
        type: {
            type: String,
            default: 'text',
        },
        inputGroup: null,
        prepend: Boolean,
        icon: null,
        step: {
            type: Number,
            default: undefined,
        },
        hideStep: Boolean,
        alignRight: Boolean,
    },

    data() {
        return {
            secured: true,
        }
    },

    computed: {
        clickable() {
            return Boolean(this.$listeners.click)
        },
        locale() {
            return this.$store.getters['locale']
        },
        isPassword() {
            return this.type == 'password'
        },
        passwordType() {
            return this.secured ? 'password' : 'text'
        },
        passwordIcon() {
            return `fa-regular ${this.secured ? 'fa-eye' : 'fa-eye-slash'}`
        },
    },
    methods: {
        onClick() {
            if (this.isPassword) this.secured = !this.secured
            else if (this.clickable) this.$emit('click')
        },
    },
}
</script>

<template lang="pug">
.form-group.position-relative(:class="{'input-group': icon || isPassword ||  disabled || inputGroup || $slots.inputGroup, 'input-group-slot': $slots.inputGroup}")
    label(v-if="hasDefaultSlot || helper || lengthValidation" :for="uid" :data-disabled="disabled")
        slot
        sup(v-if="required") *
        small.input-helper(v-if="helper") {{helper}}
        template(v-if="!isNumber")
            small.length-validator(v-if="(max && !min) && !disabled && !helper") {{$t('base.max_length', {count: maxLength})}}
            small.length-validator(v-if="(min > 0 && !max) && !disabled && !helper") {{$t('base.min_length', {count: minLength})}}
            small.length-validator(v-if="min > 0 && max && !disabled && !helper") {{$t('base.min_max_length', {count: minMaxLength})}}
    input.form-control(
        ref="inputEl"
        :type="isPassword ? passwordType : type"
        :id="uid"
        :required="required"
        :aria-label="placeholder"
        :placeholder="placeholder"
        :disabled="disabled"
        :readonly="readonly"
        :lang="isNumber ? locale : undefined"
        :maxlength="isNumber ? undefined: max"
        :min="isNumber ? min : undefined"
        :max="isNumber ? max : undefined"
        :step="isNumber ? step : undefined"
        :inputmode="isNumber ? 'decimal' : undefined"
        @input="onInput"
        @blur="onBlur"
        @focus="onFocus"
        @change="onChange"
        :autocomplete="autocomplete"
        :value="internalValue"
        :class="{'hide-step': hideStep, 'form-control-xs': xs, 'form-control-sm': sm, 'form-control-lg': lg, 'pr-9': (icon || inputGroup) && !prepend, 'pl-9': (icon || inputGroup) && prepend, 'is-invalid': hasError, 'text-right': alignRight}"
    )
    .input-group(v-if="$slots.inputGroup" :class="{'input-group-prepend': prepend && !disabled, 'clickable': clickable}" @click="onClick")
        slot(name="inputGroup" v-if="$slots.inputGroup")
    .input-group-icon(v-if="inputGroup" :class="{'input-group-icon-prepend': prepend && !disabled, 'clickable': clickable}" @click="onClick")
        span {{inputGroup}}
    .input-group-icon(v-if="icon || isPassword || disabled" :class="{'input-group-icon-prepend': prepend && !disabled, 'clickable': clickable || isPassword}" @click="onClick")
        icon(:icon="isPassword ? passwordIcon : (disabled ? 'fa-solid fa-lock' : icon)" :key="`icon-${_uid}-${icon}`")
    .invalid-feedback(
        v-if="hasError"
        :class="{'cursor-pointer': needTooltip}"
        v-html="hintText"
        ref="feedback"
        v-tooltip.hover.bottom.html="needTooltip ? hintText : undefined")
</template>
